import { render, staticRenderFns } from "./TopChartSerieCheckbox.vue?vue&type=template&id=a3b83d18&scoped=true&"
import script from "./TopChartSerieCheckbox.vue?vue&type=script&lang=js&"
export * from "./TopChartSerieCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TopChartSerieCheckbox.vue?vue&type=style&index=0&id=a3b83d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b83d18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
